import { useGetRequestQuery } from "api/TenantSlug/Request/hooks";
import { AffiliateOfferDetailForm } from "components/Forms/AffiliateOfferDetailForm/AffiliateOfferDetailForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

interface AffiliateOfferDetailDrawerProps {
    requestId: string;
}

export const AffiliateOfferDetailDrawer: FC<AffiliateOfferDetailDrawerProps> = ({ requestId }) => {
    const id = DrawerId.AffiliateOfferDetail;
    const { t } = usePaldockTranslation("drawers");

    const getRequestQuery = useGetRequestQuery(requestId, {
        filter: {
            filter: {
                type: "offer",
            },
            include: "offer,user",
        },
    });

    if (!getRequestQuery.data?.user_request) {
        return <></>;
    }

    return (
        <Drawer
            drawerId={id}
            title={<DrawerTitle mainTitle={t("affiliate-offer-detail.title")} subTitles={[requestId]} />}
            searchParamsToClean={[`${id}-requestId`]}
        >
            <AffiliateOfferDetailForm request={getRequestQuery.data?.user_request} />
        </Drawer>
    );
};
